const initialState = {
  clientTrades: null,
  clientData: null,
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case 'FETCH_CLIENT_DATA_AND_TRADES': {
      if(!state.clientData || state.clientData.username !== payload.username){
        return {
          ...state,
          clientTrades: null,
          clientData: null,
        };
      }
      return state;
    }
    case 'SET_CLIENT_DATA_AND_TRADES': {
      return {
        ...state,
        clientTrades: payload.trades,
        clientData: payload.client,
      };
    }
    case 'SET_CLIENT_DATA': {
      return {
        ...state,
        clientData: payload,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ClientModal/ClientModal.reducer.js